import { BaseWebComponentDataProvider } from '../../../../framework/BaseWebComponentDataProvider';
import { RuleSetData } from '../types';

export abstract class IntegrityMonitorRuleSetFormBaseDataProvider extends BaseWebComponentDataProvider {
  public abstract getRuleSetData(ruleSetId: string): Promise<RuleSetData>;
  public abstract updateRuleSet(record: Object): Promise<Object | null>;
  public abstract createRuleSet(record: Object): Promise<Object | null>;
}
